'use client';

import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Cell, LabelList,
} from 'recharts';

interface DataPoint {
  type: string;
  count: number;
}

interface Props {
  data: DataPoint[];
}

const TYPE_COLORS: Record<string, string> = {
  'Na lokaciji': '#10b981',
  'VPN': '#8b5cf6',
  'VNC': '#f97316',
  'RDP': '#3b82f6',
  'AnyDesk': '#f43f5e',
  'TeamViewer': '#06b6d4',
};

const CustomTooltip = ({ active, payload }: { active?: boolean; payload?: Array<{ payload: DataPoint }> }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div
      className="rounded-xl border px-4 py-3 shadow-elevated"
      style={{ backgroundColor: 'hsl(var(--card))', borderColor: 'hsl(var(--border))' }}
    >
      <p className="font-semibold text-sm" style={{ color: 'hsl(var(--foreground))' }}>{d.type}</p>
      <p className="text-sm mt-1" style={{ color: 'hsl(var(--muted-foreground))' }}>
        <span className="font-bold tabular-nums" style={{ color: 'hsl(var(--accent))' }}>{d.count}</span>{' '}
        {d.count === 1 ? 'intervencija' : 'intervencija'}
      </p>
    </div>
  );
};

export default function ReportTypeChart({ data }: Props) {
  if (data.length === 0) return null;

  return (
    <div className="card p-5">
      <h3 className="font-semibold text-base mb-1" style={{ color: 'hsl(var(--foreground))' }}>
        Intervencije po tipu veze
      </h3>
      <p className="text-xs mb-5" style={{ color: 'hsl(var(--muted-foreground))' }}>
        Raspodela metoda za izabrani period
      </p>
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data} margin={{ top: 16, right: 16, left: -8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(214 20% 88%)" vertical={false} />
          <XAxis
            dataKey="type"
            tick={{ fontSize: 12, fill: 'hsl(215 15% 50%)', fontFamily: 'DM Sans' }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            tick={{ fontSize: 12, fill: 'hsl(215 15% 50%)', fontFamily: 'DM Sans' }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'hsl(214 20% 88% / 0.5)' }} />
          <Bar dataKey="count" radius={[6, 6, 0, 0]} maxBarSize={56}>
            {data.map((entry, idx) => (
              <Cell
                key={`cell-type-${entry.type}-${idx}`}
                fill={TYPE_COLORS[entry.type] || 'hsl(217 91% 60%)'}
              />
            ))}
            <LabelList
              dataKey="count"
              position="top"
              style={{ fontSize: 12, fontWeight: 600, fill: 'hsl(215 25% 15%)', fontFamily: 'DM Sans' }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}